import {
  GridRowId,
  gridRowSelectionIdsSelector,
  GridValidRowModel,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro'

export const useGridSelection = <
  TId extends GridRowId = GridRowId,
  TModel extends GridValidRowModel = GridValidRowModel,
>() => {
  const apiRef = useGridApiContext()
  const selectedIdsMap = useGridSelector(apiRef, gridRowSelectionIdsSelector)

  return selectedIdsMap as Map<TId, TModel>
}
